import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2c506eea&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c506eea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c506eea')) {
      api.createRecord('2c506eea', component.options)
    } else {
      api.reload('2c506eea', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2c506eea&scoped=true", function () {
      api.rerender('2c506eea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/distributor/all/index.vue"
export default component.exports